import url from 'url';
import Algolia from './algolia';
import { baseAlgoliaConfig, baseFacetConfig, watched } from './config';

const { location } = window;

/**
 * Mandatory props: pathname
 * @param {Object}
 */
class AlgoliaSearch {
  constructor(options) {
    this.config = {};
    Object.assign(this, options);
    Object.keys(watched).forEach(this.addAlgoliaConfig.bind(this));
    return new Algolia(this.config);
  }

  /**
   * Figures out which page we're dealing with and builds out a config
   * object for Algolia
   * @param {String} key
   */
  addAlgoliaConfig(key) {
    const regexp = new RegExp(`/?(v[1|2])?/${key}/?`, 'g');
    const isWatched = regexp.test(this.pathname);

    if (isWatched) {
      const config = Object.assign({}, baseAlgoliaConfig, watched[key]);

      config.FACET_CONFIG = config.FACET_CONFIG.map(this.mapFacetConfig);
      this.config = config;
    }
  }

  /**
   * Merges a default Algolia config object with a custom config object
   * @param {Object} config An Algolia config object
   */
  mapFacetConfig(config) {
    return Object.assign({}, baseFacetConfig, config);
  }
}

const { pathname } = url.parse(location.href);
pathname
  .toLowerCase()
  .replace(/\/+$/, '');

window.algolia = new AlgoliaSearch({ pathname });
